import { useTranslation as useI18nTranslation } from 'react-i18next';

/**
 * Custom hook wrapper for react-i18next's useTranslation
 * Provides type-safe translation access
 */
export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  
  return {
    t: (key: string, options?: Record<string, any>) => t(key, options),
    i18n,
    currentLanguage: i18n.language,
    changeLanguage: i18n.changeLanguage.bind(i18n),
  };
};

export default useTranslation;

